import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createElementVNode as _$ce, createUnknownComponentVNode as _$cc } from 'intact-vue-next';
import { Button } from '../button';
import { Icon } from '../icon';
import { getRestProps } from '../utils';
import { makeMessageStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj, _$cn2, _$cn3;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    type = _this$get.type,
    content = _this$get.content,
    children = _this$get.children,
    closable = _this$get.closable,
    hideIcon = _this$get.hideIcon,
    classNamePrefix = _this$get.classNamePrefix;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-message"] = true, _classNameObj[k + "-" + type] = type, _classNameObj[makeMessageStyles(k)] = true, _classNameObj);
  var iconMap = {
    info: 'information-fill',
    warning: 'warning-fill',
    success: 'success-fill',
    error: 'error-fill'
  };
  return _$cv('div', _extends({}, getRestProps(this), {
    'className': _$cn(classNameObj),
    'ev-mouseenter': this.delayClose.onMouseEnter,
    'ev-mouseleave': this.delayClose.onMouseLeave
  }), _$ce(2, 'div', [_$ce(2, 'div', [!hideIcon ? _$cc(Icon, {
    'className': _$cn((_$cn2 = {}, _$cn2[k + "-icon-" + (iconMap[type] || iconMap.info)] = true, _$cn2[k + "-message-icon"] = true, _$cn2))
  }) : undefined, typeof content === 'string' || typeof content === 'number' ? _$ce(2, 'div', null, 1, _$cn(k + "-message-content"), {
    'innerHTML': content
  }) : _$ce(2, 'div', children, 0, _$cn(k + "-message-content"))], 0, _$cn((_$cn3 = {}, _$cn3[k + "-message-wrapper"] = true, _$cn3[k + "-with-icon"] = !hideIcon, _$cn3))), closable ? _$cc(Button, {
    'type': 'none',
    'icon': true,
    'className': _$cn(k + "-message-close"),
    'ev-click': this.close,
    'children': _$cc(Icon, {
      'className': _$cn(k + "-icon-close"),
      'hoverable': true
    })
  }) : undefined], 0, _$cn(k + "-message-container")));
}
;